import React, { ReactElement } from 'react';
import Icon, { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import styles from './LoadingEnvironmentScreen.module.css';
import RoundedModal from '@components/roundedModal/roundedModal';
import {ReactComponent as KemuLogo} from '@src/assets/img/kemu-bot.svg';

type Props = {
  title: ReactElement | string;
}

const LoadingEnvironmentScreen = (props: Props) => {
  return (
    <RoundedModal
      title={''}
      visible={true}
      closable={false}
      noFooter={true}
      transitionName={ 'none'}
    >
      <div className={styles.Content}>
        <Icon component={KemuLogo} className={styles.Logo}/>
        <Spin spinning={true} indicator={<LoadingOutlined />} />
        <span className={styles.Label}>{props.title}</span>
      </div>
    </RoundedModal>
  );
};

export default LoadingEnvironmentScreen;
